import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);       // null = checking, false = not auth, object = auth
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const data = await authAPI.me();
      setUser(data);
      return data;
    } catch {
      // Try refresh — if refresh succeeds, /me will succeed too. This is the
      // "auto-login on app reopen" behavior. Manual /api/auth/logout clears
      // both cookies, so refresh will fail there too (expected).
      try {
        const refreshed = await authAPI.refresh();
        setUser(refreshed);
        return refreshed;
      } catch {
        setUser(false);
        return false;
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const data = await authAPI.login({ email, password });
    setUser(data);
    return data;
  };

  const loginPhone = async (phone, password) => {
    const data = await authAPI.loginPhone({ phone, password });
    setUser(data);
    return data;
  };

  const register = async (formData) => {
    const data = await authAPI.register(formData);
    setUser(data);
    return data;
  };

  const registerTailor = async (formData) => {
    const data = await authAPI.registerTailor(formData);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginPhone, register, registerTailor, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
